import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'frame']

  open(event) {
    event.preventDefault()
    this.frameTarget.textContent = 'Loading sync errors…'
    // Cleared first so reopening the same mailbox fetches again: its errors may have changed.
    this.frameTarget.removeAttribute('src')
    this.frameTarget.src = event.currentTarget.href
    this.dialogTarget.showModal()
  }

  // Every failure stops here: Turbo ignores one with no HTML (a bare 404, the plain 503), leaving "Loading" up
  // for good, and reloads the whole page for one carrying turbo-visit-control.
  response(event) {
    if (!event.detail.fetchResponse.succeeded) this.failed(event)
  }

  failed(event) {
    event.preventDefault()
    this.frameTarget.textContent = 'Sync errors could not be loaded. Close this window and try again.'
  }

  close() {
    this.dialogTarget.close()
  }

  disconnect() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }
}
